import script from "./FormField.vue?vue&type=script&setup=true&lang=js"
export * from "./FormField.vue?vue&type=script&setup=true&lang=js"

import "./FormField.vue?vue&type=style&index=0&id=3684db10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3684db10"]])

export default __exports__